import { createSlice } from '@reduxjs/toolkit';
import { IReduxState } from '../../interfaces/IReduxState';

export const DeleteFixtureSlice = createSlice({
  name: 'DeleteFixture',
  initialState: { isLoading: false, data: {} } as IReduxState,
  reducers: {
    deleteFixture: (state, _) => {
      state.isLoading = true;
    },
    successDeleteFixture: (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    },
    failureDeleteFixture: (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    },
    clearDeleteFixture: (state) => {
      state.data = {};
    },
  },
});

export const {
  deleteFixture,
  failureDeleteFixture,
  successDeleteFixture,
  clearDeleteFixture,
} = DeleteFixtureSlice.actions;

export default DeleteFixtureSlice.reducer;
